"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enums_1 = require("./enums");
const documentVersions = {
    [enums_1.DocTypeEnum.DOI]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") }
    ],
    [enums_1.DocTypeEnum.IPID_PLUS]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") },
        { docVersion: enums_1.DocVersionEnum.V2, versionDate: new Date("2026-03-19") }
    ],
    [enums_1.DocTypeEnum.IPID_ESSENTIALS]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") },
        { docVersion: enums_1.DocVersionEnum.V2, versionDate: new Date("2026-03-19") }
    ],
    [enums_1.DocTypeEnum.MLE]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") },
        { docVersion: enums_1.DocVersionEnum.V2, versionDate: new Date("2026-03-19") }
    ],
    [enums_1.DocTypeEnum.DRIVE_AWAY_DOI]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") }
    ],
    [enums_1.DocTypeEnum.DRIVE_AWAY_IPID]: [
        { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date("2025-05-01") },
        { docVersion: enums_1.DocVersionEnum.V2, versionDate: new Date("2025-10-02") }
    ]
};
const documentHelper = {
    getDocumentVersionByDateAndType(startDate, type) {
        var _a;
        const versions = documentVersions[type];
        if (!Array.isArray(versions)) {
            console.error(`Document Versions has no entry for type ${type}`);
            return null;
        }
        try {
            const latest = versions
                .map(d => (Object.assign(Object.assign({}, d), { versionDate: new Date(d.versionDate) }))) // normalize dates
                .filter(d => !Number.isNaN(d.versionDate.getTime()) && d.versionDate <= startDate)
                .reduce((latest, current) => current.versionDate > latest.versionDate ? current : latest, { docVersion: enums_1.DocVersionEnum.V1, versionDate: new Date(0) });
            return (_a = latest.docVersion) !== null && _a !== void 0 ? _a : enums_1.DocVersionEnum.V1;
        }
        catch (err) {
            console.error(`Error while finding version for type ${type}:`, err);
            return null;
        }
    }
};
exports.default = documentHelper;
//# sourceMappingURL=documentHelper.js.map